/**
 * List of useful regular expressions
 * replaceHtmlElements: Find all html elements,
 * replaceBBcode: Find anything that has ex: [h] Hello World! [/h]
 */

const regExp = {
    allDigits: /\d+/gm,
    allAlphabeticCharacters: /[a-zA-ZåäöÅÄÖ]+/gm,
    alphabeticInputAsString: `^[A-Za-zÅÄÖåäöÄäÖöØøÆæ]+([- ]?[A-Za-zÅÄÖåäöÄäÖöØøÆæ]+)*$`,
    emptyString: /^$/,
    validation: {
        correctEmail:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        zipCode: {
            sv_SE: "^(?:SE)*(\\d{5}|\\d{3}\\s\\d{2})$",
            fi_FI: "^(?:FI)*(\\d{5})$",
            nb_NO: "^(\\d{4})$",
        },
        uuid: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
    },
    replaceHtmlElements: /<\/{0,1}[^>]+>/g,
    replaceBBcode: /\[([^\]]+)\]([^\]]+)\[\/\1\]([^[]*)/g,
} as const;

export default regExp;
